import { createSelector } from 'reselect';
import { records as appStorageRecords } from '@saucelabs/sl-module-app-storage';

import { GlobalState } from '../../reducers';
import constants from './constants';
import { InstallDependentAppState } from './reducers';
import { records as rdsRecords } from '../realDeviceSelection';

const sortCurrentGroupFilesDescending = (
  files: appStorageRecords.AppStorageFile[],
  currentFile: appStorageRecords.AppStorageFile | null,
): appStorageRecords.AppStorageFile[] => {
  const unsortedFiles = [...files];

  return unsortedFiles.sort((fileA, fileB) => {
    if (fileA.group_id === currentFile?.group_id) {
      return 1;
    }
    if (fileB.group_id === currentFile?.group_id) {
      return -1;
    }
    return 0;
  });
};

const installDependentAppSelector = (state: GlobalState): InstallDependentAppState => (
  state.apps.manual.installDependentApp
);

const filesModalSelector = createSelector([
  (state: GlobalState) => state.apps.manual.session,
  installDependentAppSelector,
],
(currentSession, installDependentAppState) => {
  const currentFile = currentSession.get('appVersion') as appStorageRecords.AppStorageFile;

  return {
    // TODO: remove once it's properly typed
    currentDevice: currentSession.get('deviceDescriptor') as rdsRecords.DeviceDescriptor | null,
    currentFile,
    files: sortCurrentGroupFilesDescending(installDependentAppState.files, currentFile),
    hasDataFetched: installDependentAppState.hasDataFetched,
    isLoading: installDependentAppState.isLoading,
    searchQuery: installDependentAppState.searchQuery,
  };
});

const filesListPaginationSelector = createSelector([
  installDependentAppSelector,
],
(installDependentAppState) => ({
  currentPage: installDependentAppState.currentPage,
  itemsPerPage: constants.FETCH_FILES_PAGE_SIZE,
  totalItems: installDependentAppState.totalItems,
}));

export default {
  installDependentAppSelector,
  filesListPaginationSelector,
  filesModalSelector,
};
